// extracted by mini-css-extract-plugin
export default {"fruits_container":"FruitsBackground_fruits_container__Hek27"};